import {
  Button,
  FormInput,
  FormNumber,
  FormRoot,
  FormTextarea,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";

const ServiceChannelFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາປ້ອນຊື່ຊ່ອງທາງບໍລິການ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().default(0),
});

export type ServiceChannelFormValues = z.infer<typeof ServiceChannelFormSchema>;

export function ServiceChannelForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<ServiceChannelFormValues>;
  onSubmit: (values: { name: string; description?: string | null; orderIndex?: number }) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<ServiceChannelFormValues>({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver type inference issue
    resolver: zodResolver(ServiceChannelFormSchema) as any,
    defaultValues: {
      name: "",
      description: null,
      orderIndex: 0,
      ...initialValues,
    },
  });

  return (
    <FormRoot<ServiceChannelFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          name: vals.name,
          description: vals.description ?? null,
          orderIndex: vals.orderIndex ?? 0,
        })
      }
      className="space-y-4"
    >
      <FormInput
        name="name"
        label="ຊື່ຊ່ອງທາງບໍລິການ"
        requiredMark
        placeholder="ຕົວຢ່າງ: ຕ້ອນຮັບຫນ້າຮ້ານ, ແຊັດອອນລາຍ"
      />
      <FormTextarea
        name="description"
        label="ຄໍາອະທິບາຍ"
        placeholder="ຄໍາອະທິບາຍ (ບໍ່ບັງຄັບ)"
        rows={3}
      />
      <FormNumber
        name="orderIndex"
        label="ລໍາດັບ"
        placeholder="0"
        hint="ລໍາດັບສໍາລັບການຈັດລຽງ (ຕໍ່າກ = ສະແດງກ່ອນ)"
      />
      <div className="flex justify-end gap-2">
        <Button
          type="button"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={submitting}
          isLoading={submitting}
        >
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}

